import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/components/Home'
import Index from '@/components/index'
import Login from '@/components/admin/public/login'
import LoginNotify from '@/components/admin/public/login_notify'
//import Register from '@/components/Register'
import WelCome from '@/components/admin/public/WelCome'
import Layout from '@/components/admin/public/Layout'
import IndexLayout from '@/components/admin/public/IndexLayout'
import { resolve } from "upath";

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'index',
      component: Index,
      // Layout:IndexLayout      
    },
    // {
    //   path: '/',
    //   name: 'Home',
    //   component: Home,      
    // },
    {
      path: '/login',
      name: 'Login',
      component: Login
    },
    {
      path: '/login/notify',
      name: 'LoginNotify',
      component: LoginNotify
    },
    {
      path: '/app',
      name: 'App',
      component: resolve =>
      require(["../components/app_list.vue"], resolve)
    },
    {
      path: '/app/detail/:ClientId',
      name: 'AppDetail',
      component: resolve =>
      require(["../components/app_detail.vue"], resolve)
    },
    {
      path: '/admin',
      name: 'Admin',
      component: Layout,
      children: [{
        path: 'welcome',
        name: 'Welcome',
        component: WelCome
      }, {
        path: 'notice',
        name: 'Notice',
        component: resolve =>
          require(["../components/admin/notice.vue"], resolve)
      }]
    },
    {
      path: '/admin',
      name: 'admin',
      component: Layout,
      children: [
        {
          path: 'privilege/application_user',
          name: 'PrivilegeApplicationUser',
          component: resolve =>
            require(["../components/admin/privilege/application_user/index.vue"], resolve)
        },
        {
          path: 'privilege/application_user/add',
          name: 'PrivilegeApplicationUserAdd',
          component: resolve =>
            require(["../components/admin/privilege/application_user/manager.vue"], resolve)
        }, {
          path: 'privilege/application_user/edit/:Id',
          name: 'PrivilegeApplicationUserEdit',
          component: resolve =>
            require(["../components/admin/privilege/application_user/manager.vue"], resolve)
        },
      ]
    },
    {
      path: '/admin',
      name: 'Admin',
      component: Layout,
      children: [{
        path: 'privilege/adminmenu',
        name: 'PrivilegeAdminMenu',
        component: resolve =>
          require(["../components/Admin/Privilege/navigation_menu/index.vue"], resolve)
      }]
    },
    {
      path: '/admin',
      name: 'Admin',
      component: Layout,
      children: [{
        path: 'privilege/adminrole',
        name: 'PrivilegeAdminRole',
        component: resolve =>
          require(["../components/admin/privilege/application_role/index.vue"], resolve)
      }, {
        path: 'privilege/adminrole/authorization/:AdminRoleId',
        name: 'PrivilegeAdminRoleAuthorization',
        component: resolve =>
          require(["../components/admin/privilege/application_role/authorization.vue"], resolve)
      }, {
        path: 'privilege/adminrole/edit/:AdminRoleId',
        name: 'PrivilegeAdminRoleEdit',
        component: resolve =>
          require(["../components/admin/privilege/application_role/manage.vue"], resolve)
      }, {
        path: 'privilege/adminrole/create',
        name: 'PrivilegeAdminRoleCreate',
        component: resolve =>
          require(["../components/admin/privilege/application_role/manage.vue"], resolve)
      }]
    },
    // {
    //   path: '/admin',
    //   name: 'Admin',
    //   component: Layout,
    //   children: [{
    //     path: 'privilege/auditclient',
    //     name: 'PrivilegeAuditClient',
    //     component: resolve =>
    //       require(["../components/Admin/Privilege/Client/AuditIndex.vue"], resolve)
    //   }, {
    //     path: 'privilege/client',
    //     name: 'PrivilegeClient',
    //     component: resolve =>
    //       require(["../components/Admin/Privilege/Client/Index.vue"], resolve)
    //   }, {
    //     path: 'privilege/client/add',
    //     name: 'PrivilegeClientAdd',
    //     component: resolve =>
    //       require(["../components/Admin/Privilege/Client/ClientManager.vue"], resolve)
    //   }, {
    //     path: 'privilege/client/edit/:ClientId',
    //     name: 'PrivilegeClientEdit',
    //     component: resolve =>
    //       require(["../components/Admin/Privilege/Client/ClientManager.vue"], resolve)
    //   }]
    // },
    {
      path: '/admin',
      name: 'Admin',
      component: Layout,
      children: [{
        path: 'privilege/residentuser',
        name: 'PrivilegeResidentUser',
        component: resolve =>
          require(["../components/admin/privilege/resident_user/index.vue"], resolve)
      }, {
        path: 'privilege/residentuser/detail/:ResidentUserId',
        name: 'PrivilegeResidentUserDetail',
        component: resolve =>
          require(["../components/admin/privilege/resident_user/index.vue"], resolve)
      }]
    }, {
      path: '/admin',
      name: 'Admin',
      component: Layout,
      children: [{
        path: 'wechat/graphicmaterial',
        name: 'PrivilegeGraphicMaterial',
        component: resolve =>
          require(["../components/admin/wechat/graphic_material/index.vue"], resolve)
      }, {
        path: 'wechat/graphicmaterial/create',
        name: 'PrivilegeGraphicMaterialCreate',
        component: resolve =>
          require(["../components/admin/wechat/graphic_material/manager.vue"], resolve)
      }, {
        path: 'wechat/graphicmaterial/edit/:GraphicMaterialId',
        name: 'PrivilegeGraphicMaterialEdit',
        component: resolve =>
          require(["../components/admin/wechat/graphic_material/manager.vue"], resolve)
      }, {
        path: 'wechat/custommenu',
        name: 'PrivilegeCustomMenu',
        component: resolve =>
          require(["../components/admin/wechat/custom_menu/index.vue"], resolve)
      }, {
        path: 'wechat/keyworkdreply/keyword',
        name: 'PrivilegeKeywordReplyKeyword',
        component: resolve =>
          require(["../components/admin/wechat/keyword_reply/index.vue"], resolve)
      }, {
        path: 'wechat/keyworkdreply/keyword/create',
        name: 'PrivilegeKeywordReplyKeywordCreate',
        component: resolve =>
          require(["../components/admin/wechat/keyword_reply/manager.vue"], resolve)
      }, {
        path: 'wechat/keyworkdreply/keyword/edit/:KeywordId',
        name: 'PrivilegeKeywordReplyKeywordEdit',
        component: resolve =>
          require(["../components/admin/wechat/keyword_reply/manager.vue"], resolve)
      }, {
        path: 'wechat/keyworkdreply/auto',
        name: 'PrivilegeKeywordReplyAuto',
        component: resolve =>
          require(["../components/admin/wechat/keyword_reply/auto_reply_index.vue"], resolve)
      }, {
        path: 'wechat/keyworkdreply/subscribe',
        name: 'PrivilegeKeywordReplySubscribe',
        component: resolve =>
          require(["../components/admin/wechat/keyword_reply/subscribe_index.vue"], resolve)
      }]
    },
    {
      path: '/admin',
      name: 'Admin',
      component: Layout,
      children: [
        {
          path: 'privilege/templatemessage',
          name: 'PrivilegeTemplateMessage',
          component: resolve =>
            require(["../components/admin/privilege/template_message/index.vue"], resolve)
        },
      ]
    },

    {
      path: '/admin',
      name: 'Admin',
      component: Layout,
      children: [
        {
          path: 'privilege/clientcategory',
          name: 'PrivilegeClientCategory',
          component: resolve =>
            require(["../components/admin/privilege/client_category/index.vue"], resolve)
        },
        {
          path: 'privilege/clientcategory/add',
          name: 'PrivilegeClientCategoryAdd',
          component: resolve =>
            require(["../components/admin/privilege/client_category/manager.vue"], resolve)
        }, {
          path: 'privilege/clientcategory/edit/:ClientCategoryId',
          name: 'PrivilegeClientCategoryEdit',
          component: resolve =>
            require(["../components/admin/privilege/client_category/manager.vue"], resolve)
        },
      ]
    },

    {
      path: '/admin',
      name: 'admin',
      component: Layout,
      children: [
        {
          path: 'sc/company',
          name: 'SCCompany',
          component: resolve =>
            require(["../components/admin/sc/company/index.vue"], resolve)
        },
        {
          path: 'sc/company/add',
          name: 'SCCompanyAdd',
          component: resolve =>
            require(["../components/admin/sc/company/manager.vue"], resolve)
        }, {
          path: 'sc/company/edit/:CompanyId',
          name: 'SCCompanyEdit',
          component: resolve =>
            require(["../components/admin/sc/company/manager.vue"], resolve)
        },
        {
          path: 'sc/school',
          name: 'SCSchool',
          component: resolve =>
            require(["../components/admin/sc/school/index.vue"], resolve)
        },
        {
          path: 'sc/school/add',
          name: 'SCSchoolAdd',
          component: resolve =>
            require(["../components/admin/sc/school/manager.vue"], resolve)
        }, {
          path: 'sc/school/edit/:SchoolId',
          name: 'SCSchoolEdit',
          component: resolve =>
            require(["../components/admin/sc/school/manager.vue"], resolve)
        },
      ]
    },
    {
      path: '/admin',
      name: 'admin',
      component: Layout,
      children: [
        {
          path: 'tpds/award',
          name: 'TPDSAward',
          component: resolve =>
            require(["../components/admin/tpds/award/index.vue"], resolve)
        },
        {
          path: 'tpds/award/add',
          name: 'TPDSAwardAdd',
          component: resolve =>
            require(["../components/admin/tpds/award/manager.vue"], resolve)
        }, {
          path: 'tpds/award/edit/:AwardId',
          name: 'TPDSAwardEdit',
          component: resolve =>
            require(["../components/admin/tpds/award/manager.vue"], resolve)
        },
        {
          path: 'tpds/credits',
          name: 'TPDSCredits',
          component: resolve =>
            require(["../components/admin/tpds/credits/index.vue"], resolve)
        },
        {
          path: 'tpds/credits/add',
          name: 'TPDSCreditsAdd',
          component: resolve =>
            require(["../components/admin/tpds/credits/manager.vue"], resolve)
        }, {
          path: 'tpds/credits/edit/:CreditsID',
          name: 'TPDSCreditsEdit',
          component: resolve =>
            require(["../components/admin/tpds/credits/manager.vue"], resolve)
        },
        {
          path: 'tpds/glgzsj',
          name: 'TPDSGLGZSJ',
          component: resolve =>
            require(["../components/admin/tpds/glgzsj/index.vue"], resolve)
        },
        {
          path: 'tpds/glgzsj/add',
          name: 'TPDSGLGZSJAdd',
          component: resolve =>
            require(["../components/admin/tpds/glgzsj/manager.vue"], resolve)
        }, {
          path: 'tpds/glgzsj/edit/:GlId',
          name: 'TPDSGLGZSJEdit',
          component: resolve =>
            require(["../components/admin/tpds/glgzsj/manager.vue"], resolve)
        },
        {
          path: 'tpds/gzjl',
          name: 'TPDSGZJL',
          component: resolve =>
            require(["../components/admin/tpds/gzjl/index.vue"], resolve)
        },
        {
          path: 'tpds/gzjl/add',
          name: 'TPDSGZJLAdd',
          component: resolve =>
            require(["../components/admin/tpds/gzjl/manager.vue"], resolve)
        }, {
          path: 'tpds/gzjl/edit/:GZJLId',
          name: 'TPDSGZJLEdit',
          component: resolve =>
            require(["../components/admin/tpds/gzjl/manager.vue"], resolve)
        },
        {
          path: 'tpds/literature',
          name: 'TPDSLiterature',
          component: resolve =>
            require(["../components/admin/tpds/literature/index.vue"], resolve)
        },
        {
          path: 'tpds/literature/add',
          name: 'TPDSLiteratureAdd',
          component: resolve =>
            require(["../components/admin/tpds/literature/manager.vue"], resolve)
        }, {
          path: 'tpds/literature/edit/:LiteratureId',
          name: 'TPDSLiteratureEdit',
          component: resolve =>
            require(["../components/admin/tpds/literature/manager.vue"], resolve)
        },
        {
          path: 'tpds/project',
          name: 'TPDSProject',
          component: resolve =>
            require(["../components/admin/tpds/project/index.vue"], resolve)
        },
        {
          path: 'tpds/project/add',
          name: 'TPDSProjectAdd',
          component: resolve =>
            require(["../components/admin/tpds/project/manager.vue"], resolve)
        }, {
          path: 'tpds/project/edit/:ProjectId',
          name: 'TPDSProjectEdit',
          component: resolve =>
            require(["../components/admin/tpds/project/manager.vue"], resolve)
        },
        {
          path: 'tpds/shjzzw',
          name: 'TPDSSHJZZW',
          component: resolve =>
            require(["../components/admin/tpds/shjzzw/index.vue"], resolve)
        },
        {
          path: 'tpds/shjzzw/add',
          name: 'TPDSSHJZZWAdd',
          component: resolve =>
            require(["../components/admin/tpds/shjzzw/manager.vue"], resolve)
        }, {
          path: 'tpds/shjzzw/edit/:SHJZZWId',
          name: 'TPDSSHJZZWEdit',
          component: resolve =>
            require(["../components/admin/tpds/shjzzw/manager.vue"], resolve)
        },
        {
          path: 'tpds/teacher_extend',
          name: 'TPDSTeacherExtend',
          component: resolve =>
            require(["../components/admin/tpds/teacher_extend/index.vue"], resolve)
        },
        {
          path: 'tpds/teacher_extend/add',
          name: 'TPDSTeacherExtendAdd',
          component: resolve =>
            require(["../components/admin/tpds/teacher_extend/manager.vue"], resolve)
        }, {
          path: 'tpds/teacher_extend/edit/:ExtensionId',
          name: 'TPDSTeacherExtendEdit',
          component: resolve =>
            require(["../components/admin/tpds/teacher_extend/manager.vue"], resolve)
        },
        {
          path: 'tpds/thesis',
          name: 'TPDSThesis',
          component: resolve =>
            require(["../components/admin/tpds/thesis/index.vue"], resolve)
        },
        {
          path: 'tpds/thesis/add',
          name: 'TPDSThesisAdd',
          component: resolve =>
            require(["../components/admin/tpds/thesis/manager.vue"], resolve)
        }, {
          path: 'tpds/thesis/edit/:ThesisId',
          name: 'TPDSThesisEdit',
          component: resolve =>
            require(["../components/admin/tpds/thesis/manager.vue"], resolve)
        },
        {
          path: 'tpds/to_guide_students_competition_award',
          name: 'TPDSToGuideStudentsCompetitionAward',
          component: resolve =>
            require(["../components/admin/tpds/to_guide_students_competition_award/index.vue"], resolve)
        },
        {
          path: 'tpds/to_guide_students_competition_award/add',
          name: 'TPDSToGuideStudentsCompetitionAwardAdd',
          component: resolve =>
            require(["../components/admin/tpds/to_guide_students_competition_award/manager.vue"], resolve)
        }, {
          path: 'tpds/to_guide_students_competition_award/edit/:StudentCompetitionWinningId',
          name: 'TPDSToGuideStudentsCompetitionAwardEdit',
          component: resolve =>
            require(["../components/admin/tpds/to_guide_students_competition_award/manager.vue"], resolve)
        },
        {
          path: 'tpds/xxjl',
          name: 'TPDSXXJL',
          component: resolve =>
            require(["../components/admin/tpds/xxjl/index.vue"], resolve)
        },
        {
          path: 'tpds/xxjl/add',
          name: 'TPDSXXJLAdd',
          component: resolve =>
            require(["../components/admin/tpds/xxjl/manager.vue"], resolve)
        }, {
          path: 'tpds/xxjl/edit/:XlId',
          name: 'TPDSXXJLEdit',
          component: resolve =>
            require(["../components/admin/tpds/xxjl/manager.vue"], resolve)
        },
        {
          path: 'tpds/zyjszw',
          name: 'TPDSZYJSZW',
          component: resolve =>
            require(["../components/admin/tpds/zyjszw/index.vue"], resolve)
        },
        {
          path: 'tpds/zyjszw/add',
          name: 'TPDSZYJSZWAdd',
          component: resolve =>
            require(["../components/admin/tpds/zyjszw/manager.vue"], resolve)
        }, {
          path: 'tpds/zyjszw/edit/:ZYJSZWId',
          name: 'TPDSZYJSZWEdit',
          component: resolve =>
            require(["../components/admin/tpds/zyjszw/manager.vue"], resolve)
        },
      ]
    },
    {
      path: '/admin',
      name: 'admin',
      component: Layout,
      children: [
        {
          path: 'sc/classes_student',
          name: 'SCClassesStudent',
          component: resolve =>
            require(["../components/admin/sc/classes_student/index.vue"], resolve)
        },
        {
          path: 'sc/classes_student/add',
          name: 'SCClassesStudentAdd',
          component: resolve =>
            require(["../components/admin/sc/classes_student/manager.vue"], resolve)
        }, {
          path: 'sc/classes_student/edit/:StudentClassId',
          name: 'SCClassesStudentEdit',
          component: resolve =>
            require(["../components/admin/sc/classes_student/manager.vue"], resolve)
        },
        {
          path: 'sc/parents',
          name: 'SCParents',
          component: resolve =>
            require(["../components/admin/sc/parents/index.vue"], resolve)
        },
        {
          path: 'sc/parents/add',
          name: 'SCParentsAdd',
          component: resolve =>
            require(["../components/admin/sc/parents/manager.vue"], resolve)
        }, {
          path: 'sc/parents/edit/:ParentId',
          name: 'SCParentsEdit',
          component: resolve =>
            require(["../components/admin/sc/parents/manager.vue"], resolve)
        },
        {
          path: 'sc/student',
          name: 'SCStudent',
          component: resolve =>
            require(["../components/admin/sc/student/index.vue"], resolve)
        },
        {
          path: 'sc/student/add',
          name: 'SCStudentAdd',
          component: resolve =>
            require(["../components/admin/sc/student/manager.vue"], resolve)
        }, {
          path: 'sc/student/edit/:UserId',
          name: 'SCStudentEdit',
          component: resolve =>
            require(["../components/admin/sc/student/manager.vue"], resolve)
        },
        {
          path: 'sc/student_parents_map',
          name: 'SCStudentParentsMap',
          component: resolve =>
            require(["../components/admin/sc/student_parents_map/index.vue"], resolve)
        },
        {
          path: 'sc/student_parents_map/add',
          name: 'SCStudentParentsMapAdd',
          component: resolve =>
            require(["../components/admin/sc/student_parents_map/manager.vue"], resolve)
        }, {
          path: 'sc/student_parents_map/edit/:StudentId',
          name: 'SCStudentParentsMapEdit',
          component: resolve =>
            require(["../components/admin/sc/student_parents_map/manager.vue"], resolve)
        },
        {
          path: 'sc/teacher',
          name: 'SCTeacher',
          component: resolve =>
            require(["../components/admin/sc/teacher/index.vue"], resolve)
        },
        {
          path: 'sc/teacher/add',
          name: 'SCTeacherAdd',
          component: resolve =>
            require(["../components/admin/sc/teacher/manager.vue"], resolve)
        }, {
          path: 'sc/teacher/edit/:UserId',
          name: 'SCTeacherEdit',
          component: resolve =>
            require(["../components/admin/sc/teacher/manager.vue"], resolve)
        },
        {
          path: 'sc/teacher_class_course_map',
          name: 'SCTeacherClassCourseMap',
          component: resolve =>
            require(["../components/admin/sc/teacher_class_course_map/index.vue"], resolve)
        },
        {
          path: 'sc/teacher_class_course_map/add',
          name: 'SCTeacherClassCourseMapAdd',
          component: resolve =>
            require(["../components/admin/sc/teacher_class_course_map/manager.vue"], resolve)
        }, {
          path: 'sc/teacher_class_course_map/edit/:CourseId',
          name: 'SCTeacherClassCourseMapEdit',
          component: resolve =>
            require(["../components/admin/sc/teacher_class_course_map/manager.vue"], resolve)
        },
        {
          path: 'sc/teacher_transaction',
          name: 'SCTeacherTransaction',
          component: resolve =>
            require(["../components/admin/sc/teacher_transaction/index.vue"], resolve)
        },
        {
          path: 'sc/teacher_transaction/add',
          name: 'SCTeacherTransactionAdd',
          component: resolve =>
            require(["../components/admin/sc/teacher_transaction/manager.vue"], resolve)
        }, {
          path: 'sc/teacher_transaction/edit/:Id',
          name: 'SCTeacherTransactionEdit',
          component: resolve =>
            require(["../components/admin/sc/teacher_transaction/manager.vue"], resolve)
        },
         {
          path: 'sc/course_table',
          name: 'SCCourseTable',
          component: resolve =>
            require(["../components/admin/sc/course_table/index.vue"], resolve)
        },
      ]
    },
    {
      path: '/admin',
      name: 'admin',
      component: Layout,
      children: [
        {
          path: 'sys/admin_area',
          name: 'SysAdminArea',
          component: resolve =>
            require(["../components/admin/sys/admin_area/index.vue"], resolve)
        },
        {
          path: 'sys/admin_area/add',
          name: 'SysAdminAreaAdd',
          component: resolve =>
            require(["../components/admin/sys/admin_area/manager.vue"], resolve)
        }, {
          path: 'sys/admin_area/edit/:AreaId',
          name: 'SysAdminAreaEdit',
          component: resolve =>
            require(["../components/admin/sys/admin_area/manager.vue"], resolve)
        },
        {
          path: 'sys/dict',
          name: 'SysDict',
          component: resolve =>
            require(["../components/admin/sys/dict/index.vue"], resolve)
        },
        {
          path: 'sys/dict/add',
          name: 'SysDictAdd',
          component: resolve =>
            require(["../components/admin/sys/dict/manager.vue"], resolve)
        }, {
          path: 'sys/dict/edit/:DictId',
          name: 'SysDictEdit',
          component: resolve =>
            require(["../components/admin/sys/dict/manager.vue"], resolve)
        },
      ]
    },
    {
      path: '/admin',
      name: 'Admin',
      component: Layout,
      children: [
        {
          path: 'content/article',
          name: 'ContentArticle',
          component: resolve =>
            require(["../components/Admin/Content/Article/Index.vue"], resolve)
        },
        {
          path: 'content/article/add',
          name: 'ContentArticleAdd',
          component: resolve =>
            require(["../components/admin/content/article/manager.vue"], resolve)
        }, {
          path: 'content/article/edit/:ArticleId',
          name: 'ContentArticleEdit',
          component: resolve =>
            require(["../components/admin/content/article/manager.vue"], resolve)
        },
        {
          path: 'content/articlecategory',
          name: 'ContentArticleCategory',
          component: resolve =>
            require(["../components/admin/content/article_category/index.vue"], resolve)
        },
        {
          path: 'content/articlecategory/add',
          name: 'ContentArticleCategoryAdd',
          component: resolve =>
            require(["../components/admin/content/article_category/manager.vue"], resolve)
        }, {
          path: 'content/articlecategory/edit/:ArticleCategoryId',
          name: 'ContentArticleCategoryEdit',
          component: resolve =>
            require(["../components/admin/content/article_category/manager.vue"], resolve)
        },
        {
          path: 'content/article/protocol',
          name: 'ContentArticleProtocol',
          component: resolve =>
            require(["../components/admin/content/article/protocol.vue"], resolve)
        },
      ]
    },
    {
      path: '/admin',
      name: 'admin',
      component: Layout,
      children: [
        {
          path: 'identity_server/client',
          name: 'IdentityServerClient',
          component: resolve =>
            require(["../components/admin/identity_server/client/index.vue"], resolve)
        },
        {
          path: 'identity_server/client/add',
          name: 'IdentityServerClientAdd',
          component: resolve =>
            require(["../components/admin/identity_server/client/manager.vue"], resolve)
        }, {
          path: 'identity_server/client/edit/:Id',
          name: 'IdentityServerClientEdit',
          component: resolve =>
            require(["../components/admin/identity_server/client/manager.vue"], resolve)
        },
      ]
    },
    {
      path: '/content/ArticleList',
      name: 'ArticleList',
      component: resolve =>
        require(["../components/content/ArticleList.vue"], resolve)
    },
    {
      path: '/content/ArticleDetail/:ArticleId',
      name: 'ArticleDetail',
      component: resolve =>
        require(["../components/content/ArticleDetail.vue"], resolve)
    },
    {
      path: '/smartschoollist',
      name: 'smartschoollist',
      component: resolve =>
        require(["../components/smartschoollist.vue"], resolve)
    },
    {
      path: '/admin',
      name: 'admin',
      component: Layout,
      children: [
        {
          path: 'identity_server/api_resource',
          name: 'IdentityServerApiResource',
          component: resolve =>
            require(["../components/admin/identity_server/api_resource/index.vue"], resolve)
        },
        {
          path: 'identity_server/api_resource/add',
          name: 'IdentityServerApiResourceAdd',
          component: resolve =>
            require(["../components/admin/identity_server/api_resource/manager.vue"], resolve)
        }, {
          path: 'identity_server/api_resource/edit/:Id',
          name: 'IdentityServerApiResourceEdit',
          component: resolve =>
            require(["../components/admin/identity_server/api_resource/manager.vue"], resolve)
        },
        {
          path: 'identity_server/identity_resource',
          name: 'IdentityServerIdentityResource',
          component: resolve =>
            require(["../components/admin/identity_server/identity_resource/index.vue"], resolve)
        },
        {
          path: 'identity_server/identity_resource/add',
          name: 'IdentityServerIdentityResourceAdd',
          component: resolve =>
            require(["../components/admin/identity_server/identity_resource/manager.vue"], resolve)
        }, {
          path: 'identity_server/identity_resource/edit/:Id',
          name: 'IdentityServerIdentityResourceEdit',
          component: resolve =>
            require(["../components/admin/identity_server/identity_resource/manager.vue"], resolve)
        },
      ]
    },
    {
      path: '/admin',
      name: 'admin',
      component: Layout,
      children: [
        {
          path: 'total/base',
          name: 'TotalBase',
          component: resolve =>
            require(["../components/admin/total/base/index.vue"], resolve)
        }
      ]
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js